// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { IabCategoryListResponse } from '@par/app/core/model/dictionaries.response';

export const getIabCategoryListRequested = createAction('[SELECT IAB CATEGORY] Get Iab Category List Requested');
export const getIabCategoryListSucceeded = createAction('[SELECT IAB CATEGORY] Get Iab Category List Succeeded', props<{
  response: IabCategoryListResponse
}>());
export const getIabCategoryListFailed = createAction('[SELECT IAB CATEGORY] Get Iab Category List Failed');
